export default __webpack_public_path__ + "static/media/cer14.615911d7.png";